// extracted by mini-css-extract-plugin
export var container = "_o8-0";
export var dotAnimation = "_o8-2";
export var dotsLoading = "_o8-1";